import cz from '../csCZ/contact_form';

const en: typeof cz = {
	fields: {
		name: 'Name',
		email: 'E-mail',
		question: 'Question',
	},
	submit_button: 'Send',
	question_submitted: 'Question submitted',
};

export default en;
